exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mainProduct__star,.mainProduct__starListItem,.mainProduct__starsList{display:inline-block}.mainProduct__star{margin:0 2px 0 0;width:16px;height:16px}.mainProduct__star_bright{background:url(" + require("../assets/star-bright.svg") + ");background-size:cover}.mainProduct__star_gray{background:url(" + require("../assets/star-gray.svg") + ");background-size:cover}@media only screen and (max-width:935px){.mainProduct__star{margin:0 2px 0 0;width:16px;height:16px}}@media only screen and (max-width:730px){.mainProduct__star{margin:0 2px 0 0;width:16px;height:16px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ef2fbce8","scoped":false,"hasInlineConfig":false}!./~/autoprefixer-loader!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/starsList.vue
// module id = 31
// module chunks = 0